var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0744 5.49173L16.6407 0.406237C15.6477 -0.135412 14.444 -0.135412 13.451 0.406237L4.01723 5.49173C3.32512 5.86787 2.90383 6.59007 2.90383 7.41759C2.90383 8.23007 3.32512 8.96731 4.01723 9.34346L13.451 14.429C13.9475 14.6998 14.5042 14.8352 15.0458 14.8352C15.5875 14.8352 16.1442 14.6998 16.6407 14.429L26.0744 9.34346C26.7665 8.96731 27.1878 8.24511 27.1878 7.41759C27.1878 6.59007 26.7665 5.86787 26.0744 5.49173Z",
    fill: "#27282A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.9013 16.1878L3.11449 11.7944C2.43742 11.4634 1.65504 11.4935 1.02312 11.8847C0.376146 12.291 0 12.968 0 13.7203V22.0106C0 23.4399 0.797429 24.7339 2.07632 25.3808L10.848 29.7742C11.176 29.9368 11.5397 30.0138 11.9053 29.998C12.271 29.9822 12.6267 29.8742 12.9394 29.6839C13.5864 29.2927 13.9625 28.6006 13.9625 27.8483V19.5581C13.9776 18.1137 13.1801 16.8198 11.9013 16.1878ZM29.0685 11.8847C28.4216 11.4935 27.6392 11.4484 26.9772 11.7944L18.2055 16.1878C16.9266 16.8348 16.1291 18.1137 16.1291 19.5581V27.8483C16.1291 28.6006 16.5053 29.2927 17.1522 29.6839C17.4649 29.8742 17.8207 29.9822 18.1863 29.998C18.552 30.0138 18.9157 29.9368 19.2436 29.7742L28.0153 25.3808C29.2942 24.7339 30.0917 23.455 30.0917 22.0106V13.7203C30.0917 12.968 29.7155 12.291 29.0685 11.8847Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.a984443ed19420fe1f23889b5c56358e.svg";
export { ForwardRef as ReactComponent };